import React from "react";
import HeaderSection from "../../components/header";
import image2 from "../../assets/gallerybgimg.png";
import CommonHeroSection from "../../components/CommonHeroSection/CommonHeroSection";
import Footer from "../../components/footerSection";
import GetInTouch from "./GetInTouch";


export default function ContactUsPage() {
  return (
    <div>
      <HeaderSection />
      <CommonHeroSection
        imgName={image2}
        titleHead="Contact Us"
        extraContent={`Home > Contact Us`}
      />

      <GetInTouch />
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d31417415.58602839!2d89.4862087264871!3d61.27441814006556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1717783139494!5m2!1sen!2sin"
        width="100%"
        height="800"
        style={{border:0}}
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
      <Footer />
    </div>
  );
}
